import { render } from "./DetailsSection.vue?vue&type=template&id=7d6a8d3a&scoped=true"
import script from "./DetailsSection.vue?vue&type=script&lang=js"
export * from "./DetailsSection.vue?vue&type=script&lang=js"

import "./DetailsSection.vue?vue&type=style&index=0&id=7d6a8d3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d6a8d3a"]])

export default __exports__